import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { isDevOnlyFeatureEnabled } from './utils/env';

import Layout from './Layout/Layout';

import Dashboard from './Pages/Dashboard';
import BatchList from './Pages/Batch/BatchList';
import BatchDetail from './Pages/Batch/BatchDetail';
import ProgramList from './Pages/Program/ProgramList';
import EmployeeList from './Pages/Employees/EmployeeList';
import EmployeeDetail from './Pages/Employees/EmployeeDetail';
import EmployeeAccess from './Pages/Employees/EmployeeAccess';
import MyProgress from './Pages/Employees/MyProgress';
import RoleList from './Pages/Roles/RoleList';
import RoleForm from './Pages/Roles/RoleForm';
import Login from './Pages/login';
import DivisionList from './Pages/Division/DivisionList';
import DivisionDetail from './Pages/Division/DivisionDetail';
import ProgramDetail from './Pages/Program/ProgramDetail';
import BatchAdd from './Pages/Batch/BatchAdd';
import AddSectionsToProgram from './Pages/Program/Section/AddSectionsToProgram';
import AddSectionsToBatch from './Pages/Batch/Section/AddSectionsToBatch';
import ProtectedRoute from './Components/ProtectedRoute';
import ProgramAdd from './Pages/Program/ProgramAdd';
import EmployeeAdd from './Pages/Employees/EmployeeAdd';
import EmployeeEdit from './Pages/Employees/EmployeeEdit';
import InsightsPage from './Pages/Dashboard/InsightsPage';
import SettingsPage from './Pages/Settings/SettingsPage';
import ExecutiveApiPage from './Pages/ExecutiveApi/ExecutiveApiPage';

function App() {
  return (
    <Routes>
      <Route
        path='login'
        element={<Login />}
      />
      <Route element={<ProtectedRoute />}>
        <Route
          path='/'
          element={<Layout />}
        >
          <Route
            index
            element={<Dashboard />}
          />
          <Route path='dashboard'>
            <Route
              index
              element={<Dashboard />}
            />
            <Route
              path='insights'
              element={<InsightsPage />}
            />
          </Route>
          <Route path='batch'>
            <Route
              index
              element={<BatchList />}
            />
            <Route
              path=':id'
              element={<BatchDetail />}
            />
            <Route
              path='add'
              element={<BatchAdd />}
            />
            <Route
              path=':id/add-section'
              element={<AddSectionsToBatch />}
            />
          </Route>
          <Route path='division'>
            <Route
              index
              element={<DivisionList />}
            />
            <Route
              path=':id'
              element={<DivisionDetail />}
            />
          </Route>
          <Route path='program'>
            <Route
              index
              element={<ProgramList />}
            />
            <Route
              path=':id'
              element={<ProgramDetail />}
            />
            <Route
              path='add'
              element={<ProgramAdd />}
            />
            <Route
              path=':id/add-section'
              element={<AddSectionsToProgram />}
            />
          </Route>
          <Route path='employee'>
            <Route
              index
              element={<EmployeeList />}
            />
            <Route
              path='my-progress'
              element={isDevOnlyFeatureEnabled() ? <MyProgress /> : <Navigate to='/employee' replace />}
            />
            <Route
              path=':id'
              element={<EmployeeDetail />}
            />
            <Route
              path=':id/access'
              element={<EmployeeAccess />}
            />
            <Route
              path='add'
              element={<EmployeeAdd />}
            />
            <Route
              path='edit/:id'
              element={<EmployeeEdit />}
            />
          </Route>
          <Route path='roles'>
            <Route
              index
              element={<RoleList />}
            />
            <Route
              path='add'
              element={<RoleForm />}
            />
            <Route
              path=':id'
              element={<RoleForm />}
            />
          </Route>
          <Route
            path='executive-api'
            element={<ExecutiveApiPage />}
          />
          <Route
            path='settings'
            element={<SettingsPage />}
          />
        </Route>
      </Route>
    </Routes>
  );
}

export default App;
